require('videogular');
require('./vg-poster');

module.exports = 'com.2fdevs.videogular.plugins.poster';



// WEBPACK FOOTER //
// ./node_modules/videogular-poster/index.js